export default {
    API_URL: process.env.VUE_APP_API_URL,
    IMAGE_URL: process.env.VUE_APP_IMAGE_URL,

    devServer: {
        disableHostCheck: true
    }

}